import {
  ClockCountdownIcon,
  CreditCardIcon,
  HeadsetIcon,
  PackageIcon,
  PresentationChartIcon,
  SealPercentIcon,
  SquaresFourIcon,
  TractorIcon,
  UserGearIcon,
  UsersThreeIcon,
  WrenchIcon,
} from '@phosphor-icons/react';
import type { ReactNode } from 'react';

import type { Role } from '@/types';

import { routes } from './routes';

export type NavItem = {
  key: string;
  label: string;
  icon: ReactNode;
  section?: string;
  to: string;
  roles?: Role[];
};

export const nav: NavItem[] = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    icon: <SquaresFourIcon size={16} />,
    to: routes.dashboard,
  },

  {
    key: 'orders',
    label: 'Orders',
    icon: <PackageIcon size={16} />,
    section: 'Business',
    // must match ORDERS_ROLES in src/features/orders/constants.ts
    // (config cannot import from feature under eslint-plugin-boundaries)
    roles: ['super_admin', 'admin', 'customer_support_logistics'],
    to: routes.orders,
  },
  {
    key: 'products',
    label: 'Products',
    icon: <TractorIcon size={16} />,
    section: 'Business',
    roles: ['admin', 'super_admin'],
    to: routes.products,
  },
  {
    key: 'customers',
    label: 'Customers',
    icon: <UsersThreeIcon size={16} />,
    section: 'Business',
    to: routes.customers,
  },

  {
    key: 'requests',
    label: 'Request',
    icon: <WrenchIcon size={16} />,
    section: 'Support',
    to: routes.requests,
  },
  {
    key: 'support',
    label: 'Support Tickets',
    icon: <HeadsetIcon size={16} />,
    section: 'Support',
    to: routes.support,
  },

  {
    key: 'payments',
    label: 'Payments',
    icon: <CreditCardIcon size={16} />,
    section: 'Finances',
    to: routes.payments,
  },
  {
    key: 'reports',
    label: 'Reports',
    icon: <PresentationChartIcon size={16} />,
    section: 'Finances',
    to: routes.reports,
  },

  {
    key: 'activity-log',
    label: 'Activity Log',
    icon: <ClockCountdownIcon size={16} />,
    section: 'Admin',
    to: routes.activityLog,
  },
  {
    key: 'discounts',
    label: 'Discounts',
    icon: <SealPercentIcon size={16} />,
    section: 'Admin',
    roles: ['admin', 'super_admin'],
    to: routes.configDiscounts,
  },
  {
    key: 'admin-users',
    label: 'Internal Users',
    icon: <UserGearIcon size={16} />,
    section: 'Admin',
    roles: ['admin', 'super_admin'],
    to: routes.adminUsers,
  },
];
